var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreaWiseReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    rx: 5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 31.5001L31.5 28.5001V20.7871C34.0815 20.1166 36 17.7871 36 15.0001C36 11.6911 33.309 9.00008 30 9.00008C26.691 9.00008 24 11.6911 24 15.0001C24 17.7871 25.9185 20.1166 28.5 20.7871V28.5001L30 31.5001Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4005 21.8446L35.601 24.7366C39.4875 25.8106 42 27.8761 42 30.0001C42 32.8381 37.0725 36.0001 30 36.0001C22.9275 36.0001 18 32.8381 18 30.0001C18 27.8761 20.5125 25.8106 24.4005 24.7351L23.601 21.8431C18.2955 23.3101 15 26.4346 15 30.0001C15 35.0461 21.5895 39.0001 30 39.0001C38.4105 39.0001 45 35.0461 45 30.0001C45 26.4346 41.7045 23.3101 36.4005 21.8446Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaWiseReport);
export default __webpack_public_path__ + "static/media/area-wise-report.32ab271fd463bcc7e8d5e212fb964f9f.svg";
export { ForwardRef as ReactComponent };